import { Graphics, Text } from 'pixi.js';
import { Scene } from '../core/Scene';
import type { SceneManager } from '../core/SceneManager';
import { SceneType } from '../core/SceneType';
import { GAME_WIDTH, GAME_HEIGHT } from '../constants';

export class InterstitialScene extends Scene {
  private sceneManager: SceneManager;

  constructor(sceneManager: SceneManager) {
    super();
    this.sceneManager = sceneManager;

    const bg = new Graphics();
    bg.rect(0, 0, GAME_WIDTH, GAME_HEIGHT);
    bg.fill(0x1a1a2e);
    this.container.addChild(bg);

    const text = new Text({
      text: 'Hole Complete — tap to continue',
      style: { fill: 0xffffff, fontSize: 36, fontFamily: 'monospace' },
    });
    text.anchor.set(0.5);
    text.x = GAME_WIDTH / 2;
    text.y = GAME_HEIGHT / 2;
    this.container.addChild(text);

    this.container.eventMode = 'static';
    this.container.on('pointerdown', () => {
      this.sceneManager.go(SceneType.Playing);
    });
  }

  enter(): void {
    // nothing to set up yet
  }

  update(_deltaTime: number): void {
    // nothing to update yet
  }

  exit(): void {
    // nothing to clean up
  }
}
